const state = {
  show_thumbs: true,
  show_tag_filter: false,
  search_by_string: '',
  drop_allowed: false,
  selected_library_folder: {},
  media_reloading: false,
  media_list: [],
  extension_list: [],
  media_selected_left: [],
  media_selected_right: [],
  playitems_selected_right: [],
  playitems_selected_left: [],
  local_playlists_cache: [],
  dragged_over_playitem: null,
  breadcrumbs: [],
  media_count: undefined,
  media_tags: [],
  media_edit_history: [],
  media_tags_unused: [],
  media_types: [],
  media_filter: {
    left: {
      mediaTags: [],
      mediaTagsAll: false,
      mediaTypes: []
    },
    right: {
      mediaTags: [],
      mediaTagsAll: false,
      mediaTypes: []
    }
  },
  pagination: {
    left: {
      offset: 0,
      limit: 10,
      page: 1
    },
    right: {
      offset: 0,
      limit: 10,
      page: 1
    }
  }
}

export default state



//////////////////
// WEBPACK FOOTER
// ./state/medium/medium.state.js
// module id = null
// module chunks = 